'use client'

import { useMergeRefs } from '@floating-ui/react'
import {
  HTMLProps,
  ReactElement,
  cloneElement,
  isValidElement,
  ReactNode,
  FC,
  Ref
} from 'react'

import { usePopoverContext } from './popover'

type PopoverTriggerProps = (
  | {
      children?: ReactElement<$TSFixMe>
      asChild?: true
      ref?: Ref<HTMLElement>
    }
  | {
      children: ReactNode
      asChild?: false
      ref?: Ref<HTMLElement>
    }
) &
  HTMLProps<HTMLElement>

export const PopoverTrigger: FC<PopoverTriggerProps> = ({
  children,
  asChild = false,
  ref,
  ...props
}) => {
  const { refs, getReferenceProps, open } = usePopoverContext()

  const mergedRef = useMergeRefs([
    (children as $TSFixMe).ref,
    ref,
    refs.setReference
  ])

  // `asChild` allows the user to pass any element as the anchor
  if (asChild && isValidElement(children)) {
    return cloneElement(
      children,
      getReferenceProps({
        ...props,
        ...children.props,
        ref: mergedRef,
        'data-state': open ? 'open' : 'closed',
        'aria-label': children.props['aria-label'] || props['aria-label']
      })
    )
  }

  return (
    <button
      type="button"
      // The user can style the trigger based on the state
      data-state={open ? 'open' : 'closed'}
      {...getReferenceProps({
        ...props,
        ref: mergedRef
      })}>
      {children}
    </button>
  )
}
